import { useAppSelector } from '../../hooks/redux';
import PageHero from '../../components/PageHero';

export default function AboutPage() {
  const content = useAppSelector((s) => s.geo.content);
  return (
    <>
      <PageHero badge={content.countryLabel} title={content.about.title} subtitle={content.about.paragraphs[0]} />
      <section style={{ padding: '64px 0', background: '#FFFBF8' }}>
        <div className="container-wide" style={{ maxWidth: 800 }}>
          {content.about.paragraphs.map((p) => (
            <p key={p.slice(0, 24)} style={{ fontSize: 16, color: '#4A2535', lineHeight: 1.85, marginBottom: 20 }}>{p}</p>
          ))}
          <p style={{ fontSize: 16, color: '#4A2535', lineHeight: 1.85 }}>
            Credit rating is part of fundraising on Micus — not a disconnected side process. That is how we help customers raise in a shorter span of time.
          </p>
        </div>
      </section>
    </>
  );
}
